import { css } from '@emotion/react'
import cloudBack from '../../assets/svg/nubefondo_requisitos.svg'
import Colors from '../../utils/colors'

const Styles = ({ colors }) => {
  const { primary, secondary } = Colors()
  const { scales: { grayShades } } = colors

  return ({
    curveBack: css`
      display: flex;
      padding: 3.75rem 0 2.25rem 0;
      clip-path: ellipse(203% 100% at 100% 100%);
      position: relative;
      margin-top: -4.25rem;
      background: url(${cloudBack}) no-repeat 2% 28% /13%, url(${cloudBack}) no-repeat 100% 84%/13%;
      background-color: ${secondary};
      @media (max-width: 767px) {
        clip-path: ellipse(290% 100% at 70% 100%);
        height: 100%;
        text-align: center;
        margin-top: -3.125rem;
        padding: 2.5rem 1rem 1rem;
        background: ${secondary};
      }
    `,
    subMain: css`
      max-width: 68rem;
      margin: 0 auto;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      @media (max-width: 767px) {
        flex-direction: column;
      }
    `,
    list: css`
      list-style-type: none;
      padding: 0;
      img{
        margin: 0 .75rem 0 0;
      }
    `,
    listElement: css`
      display: flex;
      align-items: center;
      margin: 0 0 2.188rem;
      text-align: left;
      &:last-child {
        margin: 0;
      }
    `,
    link: css`
      cursor: pointer;
      color: ${primary} !important
    `,
    inline: css`
      display: inline-flex;
      align-items: end;
      @media (max-width: 767px) {
        display: inline-block;
        align-items: center;
      }
    `,
    subtitle: css`
      padding-bottom: 1.5rem;
      width: 75%;
      @media (max-width: 767px) {
        width: 100%
      }
    `,
    titleCard: css`
      padding-bottom: 1.5rem;
      text-align: center;
    `,
    card: css`
      height: auto !important;
      background: ${grayShades[0]};
      margin-bottom: 1.5rem;
      padding: 2.25rem !important;
      width: 32.875rem !important;
      @media (max-width: 767px) {
        padding: 1.5rem !important;
        height: auto !important;
        width: auto !important;
      }
    `,
    contain: css`
      display: flex;
      flex-direction: column;
    `
  })
}

export { Styles }
